// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"bc5fe658","157":"d01a016e","244":"7249f6bb","551":"39e2d153","555":"35f8c5cf","590":"6a087926","642":"d3fbfb9a","708":"1d6021bb","813":"3f1567d8","926":"b21331e0","983":"0711b2e4"}[chunkId] + ".chunk.js";
};